import { createContext, useContext } from "react";

import type { FC, ReactNode } from "react";

/** Called after a proposal rate is successfully persisted. */
export type OnProposalRateUpdated = () => void;

const ProposalRateUpdateContext = createContext<
  OnProposalRateUpdated | undefined
>(undefined);

export const ProposalRateUpdateProvider: FC<{
  onUpdated: OnProposalRateUpdated;
  children: ReactNode;
}> = ({ onUpdated, children }) => (
  <ProposalRateUpdateContext.Provider value={onUpdated}>
    {children}
  </ProposalRateUpdateContext.Provider>
);

/** Returns the proposal-rate-updated callback, or undefined when not inside a provider. */
export const useProposalRateUpdateCallback = ():
  | OnProposalRateUpdated
  | undefined => useContext(ProposalRateUpdateContext);
